// extracted by mini-css-extract-plugin
export default {"tooltip":"pU-z","arrow":"qU-z"};